import { schema } from 'normalizr';

export const name = 'users';

export const userSchema = new schema.Entity(name);
